import { render } from "./NavCatHeaders.vue?vue&type=template&id=435bafe8&scoped=true"
import script from "./NavCatHeaders.vue?vue&type=script&lang=js"
export * from "./NavCatHeaders.vue?vue&type=script&lang=js"

import "./NavCatHeaders.vue?vue&type=style&index=0&id=435bafe8&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-435bafe8"]])

export default __exports__